import { Link } from "react-router-dom";
import { ArrowRight, Building2 } from "lucide-react";
import { motion } from "framer-motion";
import { Badge } from "@/components/ui/badge";
import { easeOutStrong } from "@/lib/motion";

const MotionLink = motion(Link);

export default function CaseStudyCard({ caseStudy }) {
    const cover = caseStudy.images?.[0];
    return (
        <MotionLink
            to={`/case-studies/${caseStudy.slug}`}
            data-testid={`case-study-card-${caseStudy.slug}`}
            className="group bg-white border border-slate-200 rounded-2xl overflow-hidden flex flex-col"
            whileHover={{
                y: -8,
                scale: 1.02,
                boxShadow: "0 20px 40px -12px rgba(124, 107, 255, 0.35)",
            }}
            whileTap={{ scale: 0.99 }}
            transition={{ duration: 0.25, ease: easeOutStrong }}
            style={{ willChange: "transform" }}
        >
            <div className="aspect-[16/9] bg-slate-100 relative overflow-hidden">
                {cover ? (
                    <img
                        src={cover}
                        alt={caseStudy.title}
                        className="absolute inset-0 w-full h-full object-cover group-hover:scale-[1.06] transition-transform duration-700"
                    />
                ) : (
                    <div className="absolute inset-0 grid place-items-center text-slate-400">
                        <Building2 className="w-10 h-10" />
                    </div>
                )}
                {caseStudy.is_featured && (
                    <Badge className="absolute top-3 left-3 bg-slate-950 text-white">
                        Featured
                    </Badge>
                )}
            </div>
            <div className="p-6 flex flex-col flex-1">
                <div className="label-eyebrow text-slate-500">
                    {caseStudy.client_business_type}
                </div>
                <h3 className="font-display text-lg font-bold text-slate-950 mt-2 leading-snug">
                    {caseStudy.title}
                </h3>
                <p className="text-sm text-slate-600 mt-2 leading-relaxed line-clamp-3 flex-1">
                    {caseStudy.problem}
                </p>
                <div className="mt-4 inline-flex items-center gap-1.5 text-sm font-semibold text-slate-950">
                    Read story
                    <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" />
                </div>
            </div>
        </MotionLink>
    );
}
